/// <referance path="/widget/setps/steps">
var ezdia;
(function (ezdia) {
    var pageParams = {};
    var startContainer = $('#ez-js-start-container');
    function getformatteddate(options) {
        var returnArray = [];
        $.each(options.query, function each(key, val) {
            returnArray.push({
                name: key,
                value: val
            });
        });
        return returnArray;
    }
    function getretrialUrlParams(options) {
        var returnUrlParams = '';
        $.each(options.query, function each(key, val) {
            if (key === 'email' || key === 'category') {
                returnUrlParams += "&" + key + "=" + val;
            }
        });
        return returnUrlParams;
    }
    function getQueryParams() {
        var e_1, _a;
        var index = 0;
        var queryObj = {};
        var searchParams = new URL(window.location.href).searchParams;
        try {
            for (var _b = __values(searchParams), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
                queryObj[key] = value;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (searchParams.get('reTrial') === 'true') {
            index = 1;
        }
        return {
            index: index,
            query: queryObj
        };
    }
    function welcome() {
        var queryParams = getQueryParams();
        $('#ez-js-welecome-msg-container')
            .show()
            .find('#ez-js-start-link')
            .on('click', function click() {
            $('#ez-js-welecome-msg-container').fadeOut(function fadeOut() {
                startContainer.fadeIn();
                var signupSteps = new Signup({
                    stepsObj: pageParams.signupSteps,
                    stepReviewTemplate: ezdia.templates.signUp.stepReview,
                    currentIndex: queryParams.index
                });
                signupSteps.render(queryParams);
            });
        });
    }
    function errors() {
        $('#ez-js-welecome-error-msg-container').show();
    }
    var Signup = /** @class */ (function (_super) {
        __extends(Signup, _super);
        function Signup() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Signup.prototype.render = function (options) {
            if (options.index) {
                this.retrialUrlParams = getretrialUrlParams(options);
                this.cache.urlParamsData[0] = getformatteddate(options);
            }
            _super.prototype.render.call(this);
        };
        Signup.prototype.getFieldMarkup = function (options) {
            var content = _super.prototype.getFieldMarkup.call(this, options);
            if (this.currentIndex !== 0) {
                content = $('<div>', {
                    class: 'clearfix question',
                    html: "<div class=\"text-muted\">Question " + (+options.index + 1) + ": </div>"
                }).append(content);
                content = content.prop('outerHTML');
            }
            return content;
        };
        Signup.prototype.geturl = function (options) {
            var url = _super.prototype.geturl.call(this, options);
            url = pageParams.deskUrl + url;
            if (this.retrialUrlParams) {
                url += this.retrialUrlParams;
            }
            return url;
        };
        Signup.prototype.getPostUrl = function (options) {
            var url = _super.prototype.getPostUrl.call(this, options);
            url = url ? pageParams.deskUrl + url : url;
            return url;
        };
        Signup.prototype.getFormData = function (name) {
            var content = _super.prototype.getFormData.call(this, name);
            var currentStepObject = this.getCurrentStepObject();
            if (this.currentIndex) {
                content.push({
                    name: 'totalQuestions',
                    value: currentStepObject.totalQuestions
                });
            }
            return content;
        };
        Signup.prototype.saveSuccess = function (res, button, event, data) {
            if (res.msg_code === 409) {
                var msg = res.msg ||
                    'Your application in under progress. We will send you an email in 48 hours regarding your application.';
                var container = $('#ez-js-user-register-container');
                startContainer.remove();
                container.find('h1').html(msg);
                container.fadeIn();
            }
            else {
                _super.prototype.saveSuccess.call(this, res, button, event, data);
            }
        };
        Signup.prototype.success = function () {
            var _this = this;
            var currentStepObj = this.getCurrentStepObject();
            var url = this.getPostUrl(currentStepObj);
            if (currentStepObj.page_type !== 'review' || !url) {
                startContainer.remove();
                $('#ez-js-end-container').fadeIn();
                _super.prototype.success.call(this, this);
                return;
            }
            currentStepObj = this.getCurrentStepObject();
            var email = this.geturlParamValue('email', 0);
            var category = this.geturlParamValue('category', 0);
            var content = [
                {
                    name: 'email',
                    value: email
                },
                {
                    name: 'category',
                    value: category
                }
            ];
            $.ajax({
                type: 'POST',
                url: url,
                data: content,
                dataType: 'json',
                success: function (res) {
                    if (res.success) {
                        startContainer.remove();
                        $('#ez-js-end-container').fadeIn();
                        _super.prototype.success.call(_this, _this);
                    }
                    else {
                        $.ezdia.showSuccessError({
                            error: true,
                            message: res.msg,
                            autohide: false
                        });
                    }
                }
            });
        };
        return Signup;
    }(ezdia.widgets.Steps));
    var signupObj = {
        load: function () {
            pageParams = $.ezdia.config.pageParams;
        },
        render: function () {
            this.load();
            if (pageParams.isTaskFlowExpired) {
                $('#ez-js-expire-msg-container').show();
            }
            else if (pageParams.signupSteps) {
                welcome();
            }
            else {
                errors();
            }
        }
    };
    var pages;
    (function (pages) {
        pages.signup = signupObj;
    })(pages = ezdia.pages || (ezdia.pages = {}));
    /*
     ** This $.ezdia is just for old code support
     ** DON'T USE THIS
     */
    $.ezdia.signup = signupObj;
})(ezdia || (ezdia = {}));
